/* eslint-disable linebreak-style */
/* eslint-disable react/button-has-type */
/* eslint-disable react/jsx-filename-extension */
/* eslint-disable react/prop-types */
/* eslint-disable import/extensions */
/* eslint-disable max-len */
import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom'; // Import useNavigate
import Button from '../elements/Button';
import BrandIcon from './BrandIcon';

const menuData = {
  'what-we-do': {
    title: 'What we do?',
    items: [
      { label: 'Digital Strategy', href: '/' },
      { label: 'Technology Consulting', href: '/' },
      { label: 'Cloud Solutions', href: '/' },
      { label: 'AI & Machine Learning', href: '/' },
      { label: 'Software Development', href: '/' },
    ],
    solutions: [
      { label: 'Enterprise Modernization', href: '/' },
      { label: 'Data Analytics', href: '/' },
      { label: 'Cybersecurity', href: '/' },
      { label: 'Digital Banking', href: '/' },
    ],
  },
  'who-we-are': {
    title: 'About Us',
    items: [
      { label: 'Our Company', href: '/' },
      { label: 'Industries', href: '/' },
      { label: 'Diversity, Equity & Inclusion', href: '/' },
      { label: 'Our Partners', href: '/' },
      { label: 'Corporate Sustainability', href: '/' },
      { label: 'Awards', href: '/' },
    ],
    news: [
      { label: 'Press Releases', href: '/' },
      { label: 'Events', href: '/' },
      { label: 'Insights', href: '/' },
      { label: 'Podcasts', href: '/' },
      { label: 'White Papers', href: '/' },
    ],
    latestPressRelease: {
      title: 'Latest Press Release',
      content: 'Sysneom Expands AI Capabilities with Strategic Acquisition',
    },
    latestInTheNews: {
      title: 'Latest In the News',
      content: "Sysneom's Innovative Approach to Digital Transformation",
    },
  },
};

export default function Header() {
  const [isCollapse, setIsCollapse] = useState(false);
  const [activeDropdown, setActiveDropdown] = useState(null); // For desktop dropdowns
  const [currentMenu, setCurrentMenu] = useState('main'); // For mobile menu navigation
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768); // Track screen size
  const location = useLocation();
  const navigate = useNavigate(); // Initialize useNavigate
  const path = location.pathname;

  // Toggle dropdown for desktop
  const toggleDropdown = (dropdownKey) => {
    if (activeDropdown === dropdownKey) {
      setActiveDropdown(null);
    } else {
      setActiveDropdown(dropdownKey);
    }
  };

  // Toggle mobile menu
  const toggleMobileMenu = () => {
    setIsCollapse(!isCollapse);
    if (!isCollapse) {
      setCurrentMenu('main'); // Reset to main menu when opening
    }
  };

  // Handle mobile menu item clicks
  const handleMenuItemClick = (menuKey) => {
    console.log(`Clicked on: ${menuKey}`); // Debugging
    setCurrentMenu(menuKey);
  };

  // Handle back button click
  const handleBackClick = () => {
    console.log('Clicked on Back'); // Debugging
    setCurrentMenu('main');
  };

  // Close menu when clicking outside
  useEffect(() => {
    const handleClickOutside = (e) => {
      const dropdowns = document.querySelectorAll('.header-dropdown-container');
      const buttons = document.querySelectorAll('.header-dropdown-button');
      const menu = document.querySelector('.header-menu');
      const trigger = document.querySelector('.mobile-menu-trigger');

      const isClickInsideDropdown = [...dropdowns].some((dropdown) => dropdown.contains(e.target));
      const isClickInsideButton = [...buttons].some((btn) => btn.contains(e.target));
      const isClickInsideMenu = menu && menu.contains(e.target);
      const isClickInsideTrigger = trigger && trigger.contains(e.target);

      if (!isClickInsideDropdown && !isClickInsideButton && !isClickInsideMenu && !isClickInsideTrigger) {
        setIsCollapse(false); // Close the sliding menu
        setActiveDropdown(null); // Close desktop dropdowns
        setCurrentMenu('main'); // Reset mobile menu
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  // Track screen size changes
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return (
    <header className="custom-header">
      <div className="header-container">
        <div className="header-left">
          <BrandIcon />
        </div>
        <div className={`header-center ${isCollapse ? 'active' : ''}`}>
          <nav className={`header-menu ${isCollapse ? 'active' : ''}`}>
            {/* Desktop Menu (only render on larger screens) */}
            {!isMobile && (
              <ul className="header-menu-main">
                <li className="header-menu-item-has-children">
                  <Button
                    type="button"
                    className="header-dropdown-button flex items-center px-5 py-3 dropdown-button shadow-button"
                    onClick={() => toggleDropdown('what-we-do')}
                    onKeyDown={(e) => e.key === 'Enter' && toggleDropdown('what-we-do')}
                    aria-expanded={activeDropdown === 'what-we-do'}
                  >
                    {menuData['what-we-do'].title} <i className="fa fa-angle-down" />
                  </Button>
                  <div className={`header-dropdown-container ${activeDropdown === 'what-we-do' ? 'active' : ''}`}>
                    <div className="header-dropdown-grid">
                      <div className="header-dropdown-column">
                        <h4 className="dropdown-heading">Services</h4>
                        {menuData['what-we-do'].items.map((item) => (
                          <div className="header-dropdown-item" key={item.label}>
                            <Button type="link" href={item.href}>
                              {item.label}
                            </Button>
                          </div>
                        ))}
                      </div>
                      <div className="header-dropdown-column">
                        <h4 className="dropdown-heading">Solutions</h4>
                        {menuData['what-we-do'].solutions.map((solution) => (
                          <div className="header-dropdown-item" key={solution.label}>
                            <Button type="link" href={solution.href}>
                              {solution.label}
                            </Button>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                </li>
                <li className="header-menu-item-has-children">
                  <Button
                    type="button"
                    className="header-dropdown-button flex items-center px-5 py-3 shadow-button"
                    onClick={() => toggleDropdown('who-we-are')}
                    onKeyDown={(e) => e.key === 'Enter' && toggleDropdown('who-we-are')}
                    aria-expanded={activeDropdown === 'who-we-are'}
                  >
                    {menuData['who-we-are'].title} <i className="fa fa-angle-down" />
                  </Button>
                  <div className={`header-dropdown-container ${activeDropdown === 'who-we-are' ? 'active' : ''}`}>
                    <div className="header-dropdown-grid">
                      <div className="header-dropdown-column">
                        <h4 className="dropdown-heading">About Us</h4>
                        {menuData['who-we-are'].items.map((item) => (
                          <div className="header-dropdown-item" key={item.label}>
                            <Button type="link" href={item.href}>
                              {item.label}
                            </Button>
                          </div>
                        ))}
                      </div>
                      <div className="header-dropdown-column">
                        <h4 className="dropdown-heading">In the News</h4>
                        {menuData['who-we-are'].news.map((newsItem) => (
                          <div className="header-dropdown-item" key={newsItem.label}>
                            <Button type="link" href={newsItem.href}>
                              {newsItem.label}
                            </Button>
                          </div>
                        ))}
                      </div>
                      <div className="header-dropdown-column">
                        <h4 className="dropdown-heading">{menuData['who-we-are'].latestPressRelease.title}</h4>
                        <div className="header-dropdown-item-press">
                          <Button type="link" href="/">
                            {menuData['who-we-are'].latestPressRelease.content}
                          </Button>
                        </div>
                        <hr className="separator" />
                        <h4 className="dropdown-heading">{menuData['who-we-are'].latestInTheNews.title}</h4>
                        <div className="header-dropdown-item-news">
                          <Button type="link" href="/">
                            {menuData['who-we-are'].latestInTheNews.content}
                          </Button>
                        </div>
                      </div>
                    </div>
                  </div>
                </li>
                <li>
                  <Button
                    type="button" // Changed to type="button"
                    className={`${path === '/careers' ? 'active-button' : ''} shadow-button px-5 py-3`}
                    onClick={() => navigate('/careers')} // Use navigate for navigation
                  >
                    Careers
                  </Button>
                </li>
                <li>
                  <Button
                    type="button" // Changed to type="button"
                    className={`${path === '/discuss-project' ? 'active-button' : ''} px-5 py-3 shadow-button`}
                    onClick={() => navigate('/discuss-project')} // Use navigate for navigation
                  >
                    Contact Us
                  </Button>
                </li>
              </ul>
            )}

            {/* Mobile Menu (only render on smaller screens or when explicitly opened) */}
            {isMobile && isCollapse && (
              <div className="mobile-menu">
                {/* Close Button (x) */}
                <button
                  type="button"
                  className="mobile-menu-close"
                  onClick={toggleMobileMenu}
                >
                  &times; {/* This is the 'x' symbol */}
                </button>

                {currentMenu === 'main' && (
                  <ul className="mobile-menu-main">
                    <li>
                      <Button
                        type="button"
                        className="mobile-menu-button"
                        onClick={() => handleMenuItemClick('what-we-do')}
                      >
                        What We Do
                      </Button>
                    </li>
                    <li>
                      <Button
                        type="button"
                        className="mobile-menu-button"
                        onClick={() => handleMenuItemClick('who-we-are')}
                      >
                        About Us
                      </Button>
                    </li>
                    <li>
                      <Button
                        type="button" // Changed to type="button"
                        className={`mobile-menu-button ${path === '/careers' ? 'active-button' : ''}`}
                        onClick={() => navigate('/careers')} // Use navigate for navigation
                      >
                        Careers
                      </Button>
                    </li>
                    <li>
                      <Button
                        type="button" // Changed to type="button"
                        className={`mobile-menu-button ${path === '/discuss-project' ? 'active-button' : ''}`}
                        onClick={() => navigate('/discuss-project')} // Use navigate for navigation
                      >
                        Contact Us
                      </Button>
                    </li>
                  </ul>
                )}

                {/* Sub-Menu for "What We Do" */}
                {currentMenu === 'what-we-do' && (
                  <div className="mobile-sub-menu">
                    {/* Back Button with Box Outline */}
                    <button
                      type="button"
                      className="back-button-box"
                      onClick={handleBackClick}
                    >
                      &lt; {/* This is the '<' symbol */}
                    </button>
                    <h4>Services</h4>
                    <ul className="mobile-sub-menu-list">
                      {menuData['what-we-do'].items.map((item) => (
                        <li key={item.label} className="mobile-sub-menu-item">
                          <Button type="link" href={item.href}>
                            {item.label}
                          </Button>
                        </li>
                      ))}
                    </ul>
                    <h4>Solutions</h4>
                    <ul className="mobile-sub-menu-list">
                      {menuData['what-we-do'].solutions.map((solution) => (
                        <li key={solution.label} className="mobile-sub-menu-item">
                          <Button type="link" href={solution.href}>
                            {solution.label}
                          </Button>
                        </li>
                      ))}
                    </ul>
                  </div>
                )}

                {/* Sub-Menu for "About Us" */}
                {currentMenu === 'who-we-are' && (
                  <div className="mobile-sub-menu">
                    {/* Back Button with Box Outline */}
                    <button
                      type="button"
                      className="back-button-box"
                      onClick={handleBackClick}
                    >
                      &lt; {/* This is the '<' symbol */}
                    </button>
                    <h4>About Us</h4>
                    <ul className="mobile-sub-menu-list">
                      {menuData['who-we-are'].items.map((item) => (
                        <li key={item.label} className="mobile-sub-menu-item">
                          <Button type="link" href={item.href}>
                            {item.label}
                          </Button>
                        </li>
                      ))}
                    </ul>
                    <h4>In the News</h4>
                    <ul className="mobile-sub-menu-list">
                      {menuData['who-we-are'].news.map((newsItem) => (
                        <li key={newsItem.label} className="mobile-sub-menu-item">
                          <Button type="link" href={newsItem.href}>
                            {newsItem.label}
                          </Button>
                        </li>
                      ))}
                    </ul>
                  </div>
                )}
              </div>
            )}
          </nav>
        </div>
        <div className="header-right">
          <button
            type="button"
            className="mobile-menu-trigger"
            onClick={toggleMobileMenu}
            aria-expanded={isCollapse}
          >
            <span />
          </button>
        </div>
      </div>
    </header>
  );
}
